import { Get } from '../utils/axios'
import localStorage from 'localStorage'

export const getUser = ( uid, requestError, load ) => Get(
  `/getUser?uid=${ uid }`,
  payload => localStorage.setItem( 'userLogin', JSON.stringify( payload.data ) ),
  requestError,
  load
)